import React from 'react'
import PropTypes from 'prop-types'

// Components
import { Avatar, Text, If, Panel, PanelDivider } from './..'
import LenderStats from '../LenderStats'

// utils
import { formatToPhone } from '../../helpers/format'

// Constants
import { REA, LO } from '../../constants/customerProfile'

// Styles
import styles from './ProfileCard.module.scss'

const ProfileCard = ({
  profile,
  isSponsorPresent,
  sponsorForFirstName,
  branding,
}) => {
  if (!profile) {
    return null
  }
  const {
    type,
    firstName,
    lastName,
    brandingStatement,
    corporateProfileName,
    corporateProfilePhone,
    nmls,
    phone,
    email,
    photo,
  } = profile
  const { loClientsHelped, loYearsInIndustry } = branding
  const statsPresent = loClientsHelped || loYearsInIndustry
  const phoneNumber = phone || corporateProfilePhone

  return (
    <Panel className={styles.panel}>
      <PanelDivider header className={styles.divider}>
        <Text
          transform='uppercase'
          size='s'
          color='twilight'
          weight='bold'
          letterSpacing='large'
          className={styles.type}
        >
          {type === REA ? 'Real estate pro' : 'Lending pro'}
        </Text>
        <Text size='xl' color='eggShell'>
          {`${firstName} ${lastName}`}
        </Text>
        <If condition={isSponsorPresent}>
          <Text color='eggShell' className={styles.priority}>
            {sponsorForFirstName
              ? `Trusted by ${sponsorForFirstName}`
              : 'Your main contact'}
          </Text>
        </If>
        <Avatar className={styles.avatar} src={photo} />
      </PanelDivider>
      <If condition={type === LO}>
        {brandingStatement && (
          <Text
            className={styles.note}
            transform='uppercase'
            letterSpacing='large'
            size='s'
            color='heather'
            weight='bold'
          >
            {`A note from ${firstName}`}
          </Text>
        )}
        {brandingStatement && <Text size='m'>{`"${brandingStatement}"`}</Text>}
      </If>
      <If condition={type === LO}>
        {statsPresent && (
          <Text
            transform='uppercase'
            letterSpacing='large'
            size='s'
            color='heather'
            weight='bold'
            className={styles.highlightHeader}
          >
            Highlights
          </Text>
        )}
        <LenderStats />
      </If>
      <Text
        transform='uppercase'
        letterSpacing='large'
        size='s'
        color='heather'
        weight='bold'
        className={styles.contact}
      >
        Contact info
      </Text>
      {corporateProfileName && <Text size='m'>{corporateProfileName}</Text>}
      {nmls && <Text size='m'>NMLS #{nmls}</Text>}
      {email && (
        <Text
          element='a'
          color='blue'
          size='m'
          className={styles.email}
          href={`mailto:${email}`}
        >
          {email}
        </Text>
      )}
      {phoneNumber && (
        <Text
          element='a'
          size='m'
          className={styles.phone}
          href={`tel:${phoneNumber}`}
        >
          {formatToPhone(phoneNumber)}
        </Text>
      )}
    </Panel>
  )
}

ProfileCard.propTypes = {
  profile: PropTypes.object,
  isSponsorPresent: PropTypes.bool.isRequired,
  sponsorForFirstName: PropTypes.string,
  branding: PropTypes.shape({
    loClientsHelped: PropTypes.number,
    loYearsInIndustry: PropTypes.number,
  }),
}

export default ProfileCard
